import {
  SkyscannerAskskyscannerV1Chat,
  SkyscannerAskskyscannerV1Nudge,
} from '@skyscanner-internal/ask-skyscanner-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';
import { grpcStreamingClientWrapper } from '../internals/clients/grpc/grpcStreaming';

type ChatRequest = SkyscannerAskskyscannerV1Chat.ChatRequest;
type ChatResponse = SkyscannerAskskyscannerV1Chat.ChatResponse;

export type NudgeRequest = SkyscannerAskskyscannerV1Nudge.NudgeRequest;
export type NudgeResponse = SkyscannerAskskyscannerV1Nudge.NudgeResponse;

const GRPC_ASK_SKYSCANNER_CHAT_CLIENT_NAME = 'ASK_SKYSCANNER_CHAT';
const GRPC_ASK_SKYSCANNER_NUDGE_CLIENT_NAME = 'ASK_SKYSCANNER_NUDGE';

export const ASK_SKYSCANNER_PATH_PREFIX = '/g/ask-skyscanner';
export const ASK_SKYSCANNER_TIMEOUT = 60_000;
export const ASK_SKYSCANNER_NUDGE_TIMEOUT = 10_000;

export const ASK_SKYSCANNER_HEADERS = {
  CSRF_TOKEN: 'X-CSRF-Token',
  SKYSCANNER_CLIENT: 'X-Skyscanner-Client',
  SKYSCANNER_CURRENCY: 'X-Skyscanner-Currency',
  SKYSCANNER_LOCALE: 'X-Skyscanner-Locale',
  SKYSCANNER_MARKET: 'X-Skyscanner-Market',
  SKYSCANNER_UTID: 'X-Skyscanner-Utid',
} as const;

export const askSkyscannerChatRequest = grpcStreamingClientWrapper<ChatRequest, ChatResponse>(
  SkyscannerAskskyscannerV1Chat.ChatService.Chat,
  {
    clientName: GRPC_ASK_SKYSCANNER_CHAT_CLIENT_NAME,
    pathPrefix: ASK_SKYSCANNER_PATH_PREFIX,
    timeoutMs: ASK_SKYSCANNER_TIMEOUT,
  },
);

export const askSkyscannerNudgeRequest = grpcFetchClientWrapper<NudgeRequest, NudgeResponse>(
  SkyscannerAskskyscannerV1Nudge.NudgeService.Nudge,
  {
    clientName: GRPC_ASK_SKYSCANNER_NUDGE_CLIENT_NAME,
    pathPrefix: ASK_SKYSCANNER_PATH_PREFIX,
    timeoutMs: ASK_SKYSCANNER_NUDGE_TIMEOUT,
  },
);
